import { AfterViewInit, ChangeDetectorRef, Directive, EventEmitter, Injector, Output, ViewContainerRef } from "@angular/core";

@Directive({ selector: `
	[container],
	[injector],
	[changeDetector]
`
})
export class ContainerDirective implements AfterViewInit {
	constructor(
		private _injector: Injector
	) {}
	
	@Output() container = new EventEmitter<ViewContainerRef>();
	@Output() injector = new EventEmitter<Injector>();
	@Output() changeDetector = new EventEmitter<ChangeDetectorRef>();
	
	ngAfterViewInit() {
		this.injector.emit(this._injector);
		this.container.emit(this._injector.get(ViewContainerRef));
		this.changeDetector.emit(this._injector.get(ChangeDetectorRef));
	}
}